// ============================================================
// Mock data — barrel + MockData global
// ============================================================
import { MOCK_USERS, CURRENT_USER } from './users.js';
import { MOCK_ASSISTANTS } from './assistants.js';
import { STATUS_LABELS, STATUS_FLOW } from './status.js';
import { MOCK_BIDS } from './bids.js';
import { MOCK_OPPORTUNITIES } from './opportunities.js';
import { SANDETEL } from './sandetel.js';
import { MOCK_TARIFF } from './tariff.js';
import { MOCK_LIBRARY_CLAUSES, MOCK_LIBRARY_TEMPLATES, MOCK_LIBRARY_MEMORIES } from './library.js';
import { MOCK_CALENDAR } from './calendar.js';
import { MOCK_MEMORY_INDEX } from './memoryIndex.js';
import { MOCK_CHAT_THREADS, MOCK_CHAT_MESSAGES } from './chat.js';
import { FARO } from './faro.js';

export const MockData = {
  USERS: MOCK_USERS,
  CURRENT_USER,
  ASSISTANTS: MOCK_ASSISTANTS,
  STATUS_LABELS,
  STATUS_FLOW,
  BIDS: MOCK_BIDS,
  FARO,
  OPPORTUNITIES: MOCK_OPPORTUNITIES,
  SANDETEL,
  TARIFF: MOCK_TARIFF,
  LIBRARY: {
    clauses: MOCK_LIBRARY_CLAUSES,
    templates: MOCK_LIBRARY_TEMPLATES,
    memories: MOCK_LIBRARY_MEMORIES,
  },
  CALENDAR: MOCK_CALENDAR,
  MEMORY_INDEX: MOCK_MEMORY_INDEX,
  CHAT: { threads: MOCK_CHAT_THREADS, messages: MOCK_CHAT_MESSAGES },
};

// Compatibility shim: legacy screens read `window.MockData`.
// Setting it here at module-eval time keeps the old code path working
// while still letting new code import `MockData` directly.
if (typeof window !== 'undefined') {
  window.MockData = MockData;
}

export default MockData;
